import data from '@emoji-mart/data';
import { init, SearchIndex } from 'emoji-mart';

let emojiInitialized = false;

function ensureInitialized() {
  if (!emojiInitialized) {
    init({ data });
    emojiInitialized = true;
  }
}

// Convert a shortcode to a unicode character sequence.
function lookupNativeEmoji(shortcode: string) {
  ensureInitialized();
  let id: string | undefined, skin: string | undefined;
  const matches = shortcode.match(SearchIndex.SHORTCODES_REGEX);

  if (matches) {
    id = matches[1];
    skin = matches[2];
  }

  if (!id) {
    return '🤷‍♀️';
  }

  // @ts-expect-error SearchIndex type does not reflect reality here
  const emoji = SearchIndex.get(id);

  if (skin) {
    // The skin tone is 1-indexed in the emoji short code e.g. ":+1::skin-tone-6:" is the
    // short code for the thumbs up emoji with the darkest skin tone. Since they're stored
    // in an array, we shift it by one to match the 0-index. Skin tone values range is 2-6.
    return emoji.skins[Number(skin) - 1].native;
  } else {
    return emoji.skins[0].native;
  }
}

function getShortCodeWithCurrentSkinTone(
  shortCode: string
): { shortCode: string; skin: number } | undefined {
  ensureInitialized();

  const shortCodeData = parseShortCode(shortCode);
  if (!shortCodeData) return;

  const { emoji, shortCode: baseShortCode } = shortCodeData;
  const skin = localStorage['emoji-mart.skin'] || shortCodeData.skin;

  let currentSkin = 1;
  if (emoji.skins.length > 1 && skin) {
    currentSkin = parseInt(skin, 10);
  }

  return { shortCode: baseShortCode, skin: currentSkin };
}

function getShortCodeForSkinTone(
  shortCode: string,
  skin: number
): string | undefined {
  ensureInitialized();

  const shortCodeData = parseShortCode(shortCode);
  if (!shortCodeData) return;

  const { emoji } = shortCodeData;
  return emoji.skins[skin - 1].shortcodes;
}

function parseShortCode(
  shortCode: string
): { emoji: any; shortCode: string; skin: string } | undefined {
  ensureInitialized();
  const matches = shortCode.match(SearchIndex.SHORTCODES_REGEX);
  if (!matches) return;

  const id = matches[1];
  const skin = matches[2];

  // @ts-expect-error SearchIndex type does not reflect reality here
  const emoji = SearchIndex.get(id);
  const baseShortCode = emoji.skins[0].shortcodes;

  return { emoji, shortCode: baseShortCode, skin };
}
const EMOJI_FONT_FACES = [
  'Noto Color Emoji', // Ensure consisteng SVG exports
  'apple color emoji', // Ensure proper rendering in Mac
  'Segoe UI Emoji', // Ensure proper rendering in Windows
  'Arial',
  'sans-serif', // Fallback, may have issues with the relaxed emoji
];

export {
  lookupNativeEmoji,
  getShortCodeWithCurrentSkinTone,
  getShortCodeForSkinTone,
  parseShortCode,
  EMOJI_FONT_FACES,
};
